export const verticalVariant = {
  root: {
    backgroundColor: 'neutral.900',
    gap: 0.25,
  },
  list: {
    backgroundColor: 'neutral.800',
    height: '100%',
    width: '480px',
    gap: 0,
    alignItems: 'start',
  },
  trigger: {
    width: '100%',
    minWidth: '100%',
    height: 'fit-content',
    backgroundColor: 'neutral.800',
    color: 'neutral.white',
    textWrap: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    textAlign: 'left',
    paddingLeft: 4,
    paddingRight: 1.5,
    flexGrow: 0,
    fontWeight: 'medium',
    boxShadow: 'inset 0 -2px 0 0 var(--chakra-colors-neutral-900)',
    _selected: {
      backgroundColor: 'neutral.700',
      boxShadow: `
        inset 0 -2px 0 0 var(--chakra-colors-neutral-900),
        inset 8px 0 0 0 var(--chakra-colors-blue-500)
      `,
    },
    "&:hover:not([aria-selected='true']):not([aria-disabled='true'])": {
      color: 'skyBlue',
    },
    '&[data-trigger-variant="secondary"]': {
      paddingLeft: 6.5,
      _before: {
        content: '""',
        position: 'absolute',
        left: 4,
        top: 1.5,
        bottom: 1.5,
        width: '4px',
        backgroundColor: 'neutral.700',
        borderRadius: 'none',
      },
      _selected: {
        boxShadow: 'inset 0 -2px 0 0 var(--chakra-colors-neutral-900)',
        _before: {
          backgroundColor: 'blue.500',
        },
      },
    },
  },
  contentGroup: {
    background: 'neutral.700',
  },
  content: {
    background: 'neutral.700',
  },
};
